<template>


  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card gl-container-shadow">
          <div class="card-block">
            <form action="" method="post" class="form-horizontal" @keydown.enter.prevent=''>
              <div class="form-group row gl-actionbar">
                <div class="col-md-3">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <dropdown text="" type="primary">
                        <div slot="dropdown-menu" class="dropdown-menu">
                        <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('all', 'ALL')">ALL</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('alternateName', 'Offer code')">Offer code</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('name', 'Name')">Name</a>
                            <a class="dropdown-item" href="#" v-on:click="updateSearchCriterion('businessFunction', 'Offer type')">Offer type</a>
                        </div>
                      </dropdown>
                    </div>
                    <input type="text"  v-model="searchText" id="input1-group3" name="input1-group3" class="form-control" :placeholder="`Search By ${criterion[0].toUpperCase() + criterion.slice(1)}`" @input="didUpdateSearchTerm">
                    &nbsp;
                    <span id="searchclear"class="fa fa-remove" @click="clearSearch()">&nbsp;</span>
                  </div>
                </div>
                <div class="col-md-3">
                 <loader v-if="loadingDatabase" label='Loading Database' />
                </div>
                <div class="col-md-6"><div  class="pull-right">
                  <div v-if="removeActive">
                    <button v-if="hasOrganization" type="button" class="btn btn-danger" v-on:click="didSelectRemoveLocations"><i class="fa fa-close"></i> Remove Selected Offers {{selectedEntities.length}}</button>
                    <button v-if="hasOrganization" type="button" class="btn btn-primary ml-3" v-on:click="addNewLocation"><i class="fa fa-plus"></i>&nbsp;&nbsp;New</button>
                  </div>
                  <div v-else>
                    <button v-if="hasOrganization" type="button" class="btn btn-outline-danger disabled" aria-disabled="true"><i class="fa fa-close"></i> Remove Selected Offers</button>
                    <button v-if="hasOrganization" type="button" class="btn btn-primary ml-3" v-on:click="addNewLocation"><i class="fa fa-plus"></i>&nbsp;&nbsp;New</button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <table class="table table-bordered table-responsive gl-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" class="form-check-input" @change="toggleCheckAll()" :checked="selectedAllChecked" style="margin-top:10px; z-index:999"  />
                  <dropdown id="select-all-drop"   >
                    <div slot="dropdown-menu" class="dropdown-menu" style="width: 10px">
                      <a href="#" v-html="selectedPageLabel" v-on:click="updateSelectCriterion('page')" class="dropdown-item"></a>
                      <a href="#" v-html="selectedAllLabel" v-on:click="updateSelectCriterion('all')" class="dropdown-item"></a>
                    </div>
                  </dropdown>
                 </th>
                <th>Offer code</th>
                <th>Name</th>
                <th>Offer type</th>
                <th style="text-align: center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!hasOrganization">
                <td colspan="5" class="text-center pt-5 pb-5">
                  <h3>Welcome to your GetLocal Dashboard</h3>
                  <div>You will receive a notification when your location information is available.</div>
                </td>
              </tr>
              <tr v-for="entity in entityList ">
                <td><input type="checkbox" class="form-check-input" @change="toggleCheckLocation(entity)" :checked="entity.checked"></td>
                <th>{{alternateNameLabel(entity.alternateName)}}</th>
                <th>{{nameLabel(entity.name)}}</th>
                <th>{{businessFunctionLabel(entity.businessFunction)}}</th>
                <td class="text-center"><!-- <router-link :to="{name : 'EditLocation', params : { branchCode: location.branchCode, fbKey : location['.key']}}">Edit</router-link> -->
                  <button type="button" class="btn btn-primary" v-on:click="edit(entity.id)"><i class="fa fa-edit"></i> Edit</button>
                </td>
              </tr>
            </tbody>
          </table>

          <nav aria-label="Page navigation example" v-if="hasOrganization"class="pagination-container">
            <ul class="pagination">
              <li><a href="#" class="first" v-on:click="clickedPage(1)">First</a></li>
              <li><a href="#" class="left" v-on:click="clickedPreviousPage"><</a></li>
              <li v-for="page in pages" v-bind:class="{active: page === currentPage + 1}">
                <a href="#" v-on:click="clickedPage(page)">{{page}}</a>
              </li>
              <li><a href="#" class="right" v-on:click="clickedNextPage">></a></li>
              <li><a href="#" class="last" v-on:click="clickedPage(pages.length)">Last</a></li>
            </ul>
          </nav>

        </div>
      </div>
    </div><!--/.col-->
  </div><!--/.row-->
  <modal title="Modal title" class="modal-danger" v-model="dangerModal" @ok="removeSelectedLocations" effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Are you sure you want to delete these Offers?</h4>
    </div>
    This cannot be undone.
  </modal>
  <alert :show.sync="showTop" v-model="showTop" placement="top" duration="3000" number="0" type="success" width="380px" dismissable style="margin-top: 20px;">
    <span class="icon-info-circled alert-icon-float-left"></span>
    <strong>Success</strong>
    <p>Your changes have seen saved!</p>
  </alert>
</div>

</template>

<script>
/* eslint-disable */
import { dropdown } from "vue-strap";
import modal from "vue-strap/src/Modal";
import { alert } from "vue-strap";
import loader from "./widgets/loader.vue"

let recordsPerPage = 10;
let totalPages;


export default {
  name: "offer",
  data: function() {
    return {
      loadingDatabase: false,
      dangerModal: false,
      searchText: '',
      searching: false,
      searchCriterion: 'all',
      searchCriterionName: 'ALL',
      showTop: false,
      removeActive: false,
      page: 0,
      listResults: [],
      searchResults: [],
      listChecked: {},
      firebaseNode: 'Offer',
      selectedEntities:[],
      selectedPageLabel: "PAGE &#10004;",
      selectedAllLabel: "ALL",
      selectedCriterion: "page",
      selectedAllChecked: false,
      selectedPages:{}
    };
  },
  components: {
    loader,
    modal,
    dropdown,
    alert
  },
  created: function() {
    this.listResults = []
    this.fetchDatabase()
    this.evalRemoveButton()
    this.searchText = this.$store.getters.searchText
    this.searchCriterion = this.$store.getters.criterion
    this.performSearch()
  },
  updated: function() {
    if (this.$store.state.notification) {
      this.showAlert();
      this.$store.state.notification = false
    }
  },
  methods: {
    businessFunctionLabel(val) {
          let optionsLabels = {"Banner - XS":"Mobile Banner","Banner - SM MD LG":"Desktop Banner","Site Grid":"National Offer","Location Grid":"Local Offer"}
      if (optionsLabels) {
        return optionsLabels[val]
      } else {
        return val
      }
        },
    alternateNameLabel(val) {
            return val
        },
    nameLabel(val) {
            return val
        },
    fetchDatabase() {
      this.loadingDatabase = true
      const onResult = (results) => { this.listResults = results; this.evalRemoveButton() }
      const onLoadedCallback = (firebaseNode) => {
        this.loadingDatabase = false;
        this.listResults.forEach(item => {
          item.checked = false
        })
        this.evalRemoveButton()
      }
      this.$store.dispatch('fetchDatabase', { firebaseNode: this.firebaseNode,  onFetchResult: onResult, onLoadedCallback: onLoadedCallback })
    },
    clickedPage(cpage) {
      //console.log('clicked page: ', cpage);
      this.page = cpage - 1
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    clickedPreviousPage() {
      const currentPage = this.currentPage;
      const newPage = currentPage === 0 ? 0 : currentPage - 1;
      this.page = newPage
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    clickedNextPage() {
      const currentPage = this.currentPage;
      const totalPages = Math.ceil(this.listResults.length / parseFloat(recordsPerPage));
      const newPage = currentPage === totalPages - 1 ? totalPages - 1 : currentPage + 1;
      this.page = newPage
      this.evalRemoveButton()
      this.evalCheckAllButton()
    },
    edit(entityId) {
      this.$router.push({ name: "EditOffer", params: { organization: this.$store.getters.organization.id, entityId: entityId } });
    },
    didUpdateSearchTerm(e) {
        this.page = 0
        if (e != null) {
          this.searchText = e.target.value
        }
        this.$store.dispatch('updateSearchText', this.searchText)
        this.performSearch()
    }, 
    performSearch() {
      
        this.searching = true
        let queryConfig = this.$store.getters.searchConfig(this.firebaseNode, this.searchCriterion)
        const results = this.$store.getters.searchIndex(this.firebaseNode).search(this.searchText, queryConfig)
        const map = this.$store.getters.firebaseDataMap(this.firebaseNode)
        this.searchResults = _.map(results, (item) => {
            return map[item.ref]
        })
        this.searching = false
        this.evalRemoveButton()
      },
    toggleCheckLocation(item) {
      if (item.checked === undefined) {
        item.checked = true
      } else {
        item.checked = !item.checked
      }
      this.evalRemoveButton()
    },
    updateSearchCriterion(criterion, name) {
      this.searchCriterion = criterion
      this.searchCriterionName = name
       this.$store.dispatch('updateSearchCriterion', this.searchCriterion)
      this.didUpdateSearchTerm(null)
      this.evalRemoveButton()
    },
    didEditSelectedLocations() {
      if (this.selectedEntities.length > 1) {
        this.$router.push({ name: "EditBatchOffer", params: { organization: this.$store.getters.organization.id, selectedEntities: this.selectedEntities } });
      } else {
        this.$router.push({ name: "EditOffer", params: { organization: this.$store.getters.organization.id, entityId: this.selectedEntities[0].id } });
      }
    },
    didSelectRemoveLocations() {
      // console.log('didSelectRemoveStores');
      this.dangerModal = !this.dangerModal;
    },
    addNewLocation() {
      this.$router.push( { name: 'NewOffer', params: { organization: this.$store.getters.organization.id } } )
    },
    removeSelectedLocations() {
      // console.log('removing locations....');
      this.selectedEntities = _.filter(this.listResults, entity => { return (entity.checked)?entity.checked:false });
      _.each(this.selectedEntities, entity => {

          this.$store.commit('removeItem',
          {
            firebaseNode: this.firebaseNode,
            item: entity,
          })
      });
      this.clearSearch()
      this.dangerModal = !this.dangerModal;
      this.evalRemoveButton()
    },
    clearSearch() {
      this.page = 0
      this.searchCriterion = "all"
      this.searchText = ""
      this.evalRemoveButton()
    },
    showAlert() {
      this.showTop = true
      var self = this;
    },
    evalRemoveButton() {
      this.selectedEntities = _.filter(this.listResults, entity => { return (entity.checked)?entity.checked:false });
      if (this.selectedEntities && this.selectedEntities.length > 0) {
        this.removeActive = true
      } else {
        this.removeActive = false
      }
      // console.log(this.removeActive)
    },
    evalCheckAllButton() {
      if (this.selectedCriterion == "page") {
        let pageSelected = this.selectedPages["page"+ this.page]
        if (!pageSelected) {
          this.selectedPages["page"+ this.page] = false
        }
        this.selectedAllChecked = this.selectedPages["page"+ this.page]
        this.entityList.forEach(item => {
          item.checked = this.selectedAllChecked
        })
      } else {
        this.listResults.forEach(item => {
          item.checked = this.selectedAllChecked
        })
      }
    },
    updateSelectCriterion(type) {
      if (this.searchText.trim().length > 0) {
        type = "page"
      }
      if (type == "page") {
        this.selectedPageLabel = "PAGE &#10004;"
        this.selectedAllLabel = "ALL"
        this.selectedAllChecked = false
        this.selectedPages = {}
      } else {
        this.selectedPageLabel = "PAGE"
        this.selectedAllLabel = "ALL &#10004;"
        this.selectedAllChecked = false
      }
     this.listResults.forEach(item => {
        item.checked = this.selectedAllChecked
      })
      this.selectedCriterion = type
      this.toggleCheckAll(true)

    },
    toggleCheckAll(force) {
      if (force) {
        this.selectedAllChecked = force
        if (this.selectedCriterion == "page") {
          this.selectedPages["page"+ this.page] = force
        }  
      } else {
        if (this.selectedCriterion == "page") {
          let pageSelected = this.selectedPages["page"+ this.page]
          if (!pageSelected) {
            this.selectedPages["page"+ this.page] = true
          } else {
            this.selectedPages["page"+ this.page] = false
          }
          this.selectedAllChecked = this.selectedPages["page"+ this.page]
        } else {
          this.selectedAllChecked = !this.selectedAllChecked
        }
      }
      
      this.evalCheckAllButton()
      this.evalRemoveButton()
    },
  },
  computed: {
    entityList: function() {
      if (this.searchText.trim().length > 0) {
        return this.searchResults
      }
      const start = this.currentPage * recordsPerPage;
      return this.listResults.slice(start, start + recordsPerPage);
    },
    pages: function() {
      if (this.searchText.trim().length > 0) {
        return 1
      }
      const length = Math.ceil(this.listResults.length / parseFloat(recordsPerPage));
      const pages = Array(length).fill().map((e,i)=>i+1);
      // console.log('pages::', pages);
      return pages;
    },
    currentPage: function() {
      return this.page;
    },
    criterion: function() {
      return this.searchCriterionName;
    },
    hasOrganization: function() {
      return true;
    }
  }
};
</script>

  <style>
#searchclear {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  height: 12px;
  margin: auto;
  font-size: 12px;
  cursor: pointer;
  color: #888888;
  z-index: 1000;
}

th {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #eceff1;
  border-bottom: 1px solid #cfd8dc;
}
.pagination {
  flex-flow: row wrap;
}

.pagination li {
  display: none;
}

.pagination li:nth-of-type(-n + 2),
.pagination li:nth-last-child(-n + 2),
.pagination li.active,
.pagination li.active + li,
.pagination li.active + li + li {
  display: list-item;
}
#select-all-drop button {
  margin-left: 20px;
  padding: 2px 2px 0px 0px;
  background-color: #eceff1;
}
</style>



// WEBPACK FOOTER //
// ListOffer.vue?3bb81eec